import styled from "styled-components";
export const BreadcrumbsHeaderContainer = styled.div.withConfig({
  displayName: "breadcrumbs-headerstyles__BreadcrumbsHeaderContainer",
  componentId: "sc-1shhwdz-0"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  verticalAlign: "middle"
});
